// extracted by mini-css-extract-plugin
module.exports = {"user":"UserInfoModule_user__2a6iS","name":"UserInfoModule_name__3bJhr","email":"UserInfoModule_email__2nwR6","photo":"UserInfoModule_photo__18vBV"};